import React, { createContext, useContext, ReactNode } from 'react';

export interface User {
  id: string;
  username: string;
  role: 'admin' | 'dispatcher' | 'command' | 'unit';
  robloxName: string;
  email?: string;
  unitId?: string;
  callsign?: string;
}

export interface AuthContextType {
  user: User | null;
  login: (username: string, password: string) => Promise<boolean>;
  logout: (options?: { skipServerRequest?: boolean }) => Promise<void>;
  isAuthenticated: boolean;
  loading: boolean;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
